export {  default as dataStorageQueries } from './basic'